import DashHeaderOpen from 'components/markup/headers/DashHeaderOpen';
import React, { Component } from "react";
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { CodeStyle } from 'utils/code';

class FrontendErrors extends Component {

    render() {

        return (
            <>

            <Container>

                <Helmet>
                    <title>Errors</title>
                    <meta name="description" content="Errors" />
                </Helmet>

                <DashHeaderOpen 
                    icon="fas fa-home" 
                    icon_link="/developers/development/backend" 
                    title={<span>Development</span>} breadcrumb_1="Frontend"  breadcrumb_2="Errors" 
                />
                
                <Card>
                    <CardHeader>
                        <Row className="align-items-center">
                            <Col xs="8">
                                <h3 className="mb-0">Errors</h3>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>

                                <h4>What developer hasn't thrown an error?</h4>
                                <p className="text-sm">
                                    Errors happens, it's part of life as a developer and while coffee can help get you through them prevention is everything.<br />
                                    All code that makes an outbound API request must account for the possibility of it failing.<br />
                                    Should the happen the front end user needs to be notified and, depending on the system/project, a log of the error should be created.
                                </p>

                                <h4>An example api request looking for errors</h4>
                                <p className="text-sm">Note the in the below example we are using the Single Property Check to account for any errors that may happen in this request<br />We are also toggling a system alert should anything go wrong to alert the end user. <br />We are also using a log function for this system to make it easier to debug when, where, and why this happened.</p>


                        
<SyntaxHighlighter language="javascript" style={CodeStyle} customStyle={{padding: 15}}>
{` const project_logs_clients = await architeckCall({
        method: 'get',
        url: \`/api/v1/project_logs_clients/list?find_by=project__\${found_project._id}\`
    })

    if(project_logs_clients.success) {

        this.setState({project_logs_clients: project_logs_clients.data})

    } else {

        toggleAlert(true, 'danger', 'Something went wrong fetching data for this project', 'infinite' )
        log({
            url: window.location.href, 
            file: '/store/functions/project_logs_clients.js', 
            code: 'REQUEST FAILURE', 
            text: project_logs_clients.message.toString()
        });

    }}
})`}
</SyntaxHighlighter>    
 
                    </CardBody>
                </Card>
          
            </Container>
            </>
        );
    }
}

export default FrontendErrors